
import { createTheme, Divider, IconButton, withStyles, FormControl } from '@material-ui/core';
import CardMedia from '@material-ui/core/CardMedia';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import CloseIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/CheckCircle';
import _ from 'lodash';
import React from 'react';
import { BLUE, GREEN, ORANGE, STORE_ITEMS_STATUS_MAP, STORE_ITEMS_TYPES, STORE_ITEMS_TYPES_MAP, STORE_ITEMS_CATEGORIES_MAP } from '../../_config/consts';
import CloseCircleIconCustom from '../CustomIcons/CloseCircleIconCustom.jsx';
import CreditsIconCustom from '../CustomIcons/CreditsIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import BaseStoreItemsActivationView from './StoreItemsActivationViews/BaseStoreItemsActivationView.jsx';
import RemoveIconCustom from '../CustomIcons/RemoveIconCustom.jsx';
import { isDemoSystem } from '../../_config/utils.js';
import InfoSection from '../InfoSection/InfoSection.jsx';

const styles = theme => ({
  titleText: {
    margin: 0,
    fontWeight: 800,
    color: 'white',
    fontSize: 48,
    letterSpacing: '-0.5px',
    textShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    lineHeight: 1.2,
  },
  container: {
    borderRadius: 0,
    justifyContent: 'center',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  },
  headerContainer: {
    position: 'relative',
  },
  cardBodyContainer: {
    paddingBottom: 0,
    backgroundColor: '#ffffff',
  },
  descriptionText: {
    color: '#4a5568',
    margin: 0,
    fontWeight: '400',
    marginTop: 10,
    textAlign: 'left',
    lineHeight: '1.7em',
    fontSize: 16,
  },
  sectionContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  closeContainer: {
    position: 'absolute',
    height: 40,
    width: 40,
    right: 15,
    top: 15,
    zIndex: 2000,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      transform: 'scale(1.05)',
    }
  },
  media: {
    height: 250,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    backgroundColor: 'black',
  },
  activeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 12,
    padding: '6px 12px',
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: 8,
    backdropFilter: 'blur(10px)',
    width: 'fit-content',
  },
  activeText: {
    color: GREEN,
    margin: 0,
    marginRight: 8,
    fontWeight: 700,
    fontSize: 16,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'left',
    padding: '20px 30px',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 30,
    zIndex: 10000,
  },
  requestDemoContainer: {
    marginTop: 15,
    paddingTop: 15,
  },
  requestDemoText: {
    color: '#718096',
    fontWeight: '400',
    textAlign: 'center',
    fontSize: 15,
    lineHeight: 1.6,
  },
  itemAdditionalContainer: {
    marginBottom: 25,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '12px 20px',
    backgroundColor: '#f7fafc',
    borderRadius: 10,
    border: '1px solid #e2e8f0',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#edf2f7',
      transform: 'translateX(5px)',
    }
  },
  itemAdditionalText: {
    margin: 0,
    fontWeight: 600,
    color: '#2d3748',
    marginBottom: 0,
    fontSize: 16,
    marginLeft: 15,
  },
  costText: {
    fontWeight: 700,
    color: '#2d3748',
    textAlign: 'center',
    fontSize: 18,
  },
  mask: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
    zIndex: 100,
    background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)',
  },
  resourceSelectorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 12,
  },
  resourceSelectorLabel: {
    fontWeight: 700,
    color: '#2d3748',
    marginBottom: 0,
    fontSize: 20,
    marginTop: 0,
  },
  resourceSelect: {
    minWidth: 200,
    marginLeft: 20
  },
  pricingCard: {
    backgroundColor: '#fff7ed',
    padding: '15px 25px',
    borderRadius: 12,
    border: '2px solid #fed7aa',
    minWidth: '200px',
    textAlign: 'center',
    width: '100%'
  },
  pricingCardFree: {
    backgroundColor: '#f0fdf4',
    padding: '15px 25px',
    borderRadius: 12,
    border: '2px solid #bbf7d0',
    textAlign: 'center',
    margin: '10px auto',
    width: '100%'
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

const StoreItemTypeView = ({ itemType }) => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center',
    padding: '6px 12px', 
    borderRadius: 8,
    width: 'fit-content',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  }}>
    <h4 style={{ fontSize: 12, margin: 0, color: 'white', marginRight: 6, fontWeight: 600 }}>
      <Entity entity={STORE_ITEMS_TYPES_MAP[itemType].nameSingle} />
    </h4>
    <span style={{ color: 'white', display: 'flex', alignItems: 'center', fontSize: 16 }}>{STORE_ITEMS_TYPES_MAP[itemType].icon}</span>
  </div>
);

const CategoryView = ({ category }) => {
  if (!category || !STORE_ITEMS_CATEGORIES_MAP[category]) return null;
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'row',
      alignItems: 'center',
      padding: '6px 12px',
      borderRadius: 8,
      width: 'fit-content',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    }}>
      <h4 style={{ 
        fontSize: 12, 
        margin: 0, 
        color: 'white', 
        marginRight: 6, 
        fontWeight: 600 
      }}>
        <Entity entity={STORE_ITEMS_CATEGORIES_MAP[category].nameShort} />
      </h4>
      <span style={{ color: 'white', display: 'flex', alignItems: 'center', fontSize: 16 }}>
        {STORE_ITEMS_CATEGORIES_MAP[category].icon}
      </span>
    </div>
  );
};


class StoreItemDescriptionView extends React.Component {
  constructor(props) {
    super(props);
    const { item } = this.props;
    // correctly initialize the active resource
    const activeResource = item.activeResource;
    let selectedResource = null;
    if (activeResource) {
      selectedResource = _.find(item.availableResources, resource => resource.resource === activeResource);
    }
    selectedResource = selectedResource || (item && item.availableResources && _.isArray(item.availableResources) ? item.availableResources[0] : item);
    this.state = {
      selectedResource: selectedResource,
    };
  }

  onHandleResourceChange = (event) => {
    const { item } = this.props;
    const selectedIndex = parseInt(event.target.value, 10);
    const selectedResource = item.availableResources[selectedIndex];
    this.setState({ selectedResource });
  };

  renderMultiResourcePricing = () => {
    const { classes, item } = this.props;
    const { selectedResource } = this.state;

    if (!item.availableResources || item.availableResources.length === 0) {
      return null;
    }

    // Use selected resource or default to first one
    const currentResource = selectedResource || item.availableResources[0];
    const currentIndex = _.findIndex(item.availableResources, res => res.resource === currentResource.resource);
    const isFreeItem = currentResource.fixedPrice === '0' && currentResource.burnRate === '0';
    return (
      <div>
        {/* Resource Selector */}
        <div className={classes.resourceSelectorContainer}>
          {item.isActive && item.activeResource ? (
            <InfoSection
              title="activeSubscriptionOption"
              containerStyle={{ marginTop: 0, marginBottom: 15, width: '100%', maxWidth: 500 }}
              headerStyle={{ justifyContent: 'center' }}
              subtitle={
                <h4 style={{ fontWeight: 'bold', textAlign: 'center', margin: '8px 0 0 0' }}>
                  {L20NContext.getSync(item.activeResource)}
                </h4>
              }
              gravity="success"
              titleStyle={{ fontWeight: 'normal' }}
            />
          ) : (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'row', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              width: '100%',
              gap: '20px',
              backgroundColor: '#faf7f7',
              padding: 20,
              borderRadius: 10,
            }}>
              <h4 className={classes.resourceSelectorLabel}>
                <Entity entity="selectSubscriptionOption" />
              </h4>
              <FormControl className={classes.resourceSelect}>
              <select
                value={currentIndex}
                onChange={this.onHandleResourceChange}
                style={{
                  minHeight: 44,
                  padding: '10px 16px',
                  fontSize: 16,
                  borderRadius: 10,
                  border: '2px solid #cbd5e0',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  width: '400px',
                  fontWeight: 500,
                  color: '#2d3748',
                  transition: 'all 0.2s ease',
                }}
                onFocus={(e) => e.target.style.borderColor = BLUE}
                onBlur={(e) => e.target.style.borderColor = '#cbd5e0'}
              >
                {_.map(item.availableResources, (resource, index) => (
                  <option key={resource.resource} value={index}>
                  {L20NContext.getSync(resource.resource)}
                  </option>
                ))}
              </select>
            </FormControl>
            </div>
          )}
        </div>
        {/* Pricing for selected resource */}
        {!isFreeItem ? (
          <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            justifyContent: 'space-between',
            padding: '10px 0',
            gap: '20px',

          }}>
            {(!item.activeResource || (item.activeResource && item.activeResource !== selectedResource.resource)) && (
              <div className={classes.pricingCard}>
                <h3 className={classes.costText} style={{ marginTop: 0, marginBottom: 8, fontSize: 14, fontWeight: 600, color: '#9a3412' }}>
                  <Entity entity="activationCost" />
                </h3>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ color: ORANGE, fontSize: 24, fontWeight: 700 }}>
                    <Entity entity="creditsWithNumber" key={currentResource.fixedPrice} data={{ credits: currentResource.fixedPrice }} />
                  </span>
                  <CreditsIconCustom style={{ color: ORANGE, width: 24, marginLeft: 8 }} />
                </div>
              </div>
            )}
            <div className={classes.pricingCard}>
              <h3 className={classes.costText} style={{ marginTop: 0, marginBottom: 8, fontSize: 14, fontWeight: 600, color: '#9a3412' }}>
                <Entity entity="monthlyConsumption" />
              </h3>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ color: ORANGE, fontSize: 24, fontWeight: 700 }}>
                  <Entity entity="walletCreditsConsumptionText" key={currentResource.burnRate} data={{ credits: currentResource.burnRate }} />
                </span>
                <CreditsIconCustom style={{ color: ORANGE, width: 24, marginLeft: 8 }} />
              </div>
            </div>
          </div>
        ) : (
          <div className={classes.pricingCardFree}>
            <h3 className={classes.costText} style={{ margin: 0, color: '#15803d' }}>
              <Entity entity="itemFreeOfCharge" />
            </h3>
          </div>
        )}
      </div>
    );
  };

  renderPricingSection = () => {
    const { classes, item } = this.props;
    const isFreeItem = item.fixedPrice === 0 && item.burnRate === 0 && !isDemoSystem();

    // Handle request to quote items
    if (item.requestToQuote) {
      return null;
    }
    
    // Handle items with multiple resources
    if (item.hasMultipleResources) {
      return this.renderMultiResourcePricing();
    }
    
    // Handle free items
    if (isFreeItem) {
      return (
        <div className={classes.pricingCardFree}>
          <h3 className={classes.costText} style={{ margin: 0, color: '#15803d' }}>
            <Entity entity="itemFreeOfCharge" />
          </h3>
        </div>
      );
    }
    
    // Handle standard paid items
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'space-between',
        gap: '20px',
        padding: '10px 0'
      }}>
        {!item.isActive && (
          <div className={classes.pricingCard}>
            <h3 className={classes.costText} style={{ marginTop: 0, marginBottom: 8, fontSize: 14, fontWeight: 600, color: '#9a3412' }}>
              <Entity entity="activationCost" />
            </h3>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: ORANGE, fontSize: 24, fontWeight: 700 }}>
                <Entity entity="creditsWithNumber" key={item.fixedPrice} data={{ credits: item.fixedPrice }} />
              </span>
              <CreditsIconCustom style={{ color: ORANGE, width: 24, marginLeft: 8 }} />
            </div>
          </div>
        )}
        <div className={classes.pricingCard}>
          <h3 className={classes.costText} style={{ marginTop: 0, marginBottom: 8, fontSize: 14, fontWeight: 600, color: '#9a3412' }}>
            <Entity entity="monthlyConsumption" />
          </h3>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: ORANGE, fontSize: 24, fontWeight: 700 }}>
              <Entity entity="walletCreditsConsumptionText" key={item.burnRate} data={{ credits: item.burnRate }} />
            </span>
            <CreditsIconCustom style={{ color: ORANGE, width: 24, marginLeft: 8 }} />
          </div>
        </div>
      </div>
    );
  };
  
  render() {
    const { canEditSubscription, companyInfo, walletInnerSubscriptions, onRequestQuotation, onRequestActivation, onRequestSemiAutomaticActivation, onRequestDemo, classes, item, onActivateSubscription, onClose } = this.props;
    const { selectedResource } = this.state;
    const isFreeItem = item.fixedPrice === 0 && item.burnRate === 0 && !isDemoSystem();
    const selectedItem = selectedResource ? { ...item, ...selectedResource } : item;
    const provisioningType = selectedItem.provisioningType;
    const requestToQuote = selectedItem.requestToQuote;
    const incompatibleAdditionalNotes = selectedItem.incompatibleAdditionalNotes;

    const isCompatible = item.isCompatible && item.isCompatible(companyInfo, walletInnerSubscriptions, selectedItem.resource);
    
    return (
    <MuiThemeProvider theme={theme}>
      <div style={{ padding: 0 }}>
        <div className={classes.container}>
          <div className={classes.headerContainer}>
            <div className={classes.titleContainer}>
              <h2 className={classes.titleText}>{item.renderedTitle ? item.renderedTitle : <Entity entity={item.title} />}</h2>
              {item.type !== STORE_ITEMS_TYPES.HARDWARE ? (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '10px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {item.isActive ? (
                      <div className={classes.activeContainer}>
                        <Entity className={classes.activeText} entity="storeItemActive" />
                        <CheckIcon style={{ color: GREEN, fontSize: 20 }} />
                      </div>
                    ) : (
                      <>
                      {isCompatible ? (
                        <div className={classes.activeContainer} style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}>
                          <Entity className={classes.activeText} style={{ color: 'white' }} entity="inactive" />
                          <RemoveIconCustom style={{ color: 'white', width: 20 }} />
                        </div>
                      ): (
                        <div className={classes.activeContainer} style={{ marginTop: 8, backgroundColor: 'rgba(239, 68, 68, 0.2)', borderRadius: 8 }}>
                          <Entity className={classes.activeText} entity="storeItemNotCompatible" style={{ color: '#fee2e2', fontSize: 16 }} />
                          <CloseCircleIconCustom style={{ width: 20, color: '#fee2e2' }} />
                        </div>
                      )}
                      </>
                    )}
                    {/* Type and Category chips */}
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', flexWrap: 'wrap' }}>
                      <StoreItemTypeView itemType={item.type} />
                      {item.category && (
                        <CategoryView category={item.category} />
                      )}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {item.status ? (
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', padding: '6px 12px', backgroundColor: 'rgba(255, 255, 255, 0.15)', borderRadius: 8, backdropFilter: 'blur(10px)', width: 'fit-content', alignSelf: 'flex-end' }}>
                        <h4 className={classes.activeText} style={{ color: '#e0e0e0', margin: 0, fontSize: 14 }}><Entity entity={STORE_ITEMS_STATUS_MAP[item.status].name} /></h4>
                        <span style={{ color: '#e0e0e0', fontSize: 18 }}>{STORE_ITEMS_STATUS_MAP[item.status].icon}</span>
                      </div>
                    ) : null}
                    {item.provider ? (
                      <h4 className={classes.activeText} style={{ fontSize: 13, color: '#e0e0e0', marginTop: 8, fontWeight: 500 }}><Entity entity="providedBy" />: {item.provider}</h4>
                    ): null}
                  </div>
                </div>
              ) : <div style={{ height: 20}} />}
            </div>
            <div className={classes.mask} />
            <CardMedia
              className={classes.media}
              image={item && item.previewImage ? item.previewImage : item.coverImage}
            />
            <IconButton className={classes.closeContainer} onClick={() => onClose()}>
              <CloseIcon style={{ color: 'white', fontSize: 35 }} />
            </IconButton>
          </div>
          <div className={classes.cardBodyContainer}>
            {item && item.renderedContent ? (
              <div className="storeContentContainer" style={{ 
                maxHeight: 500, 
                overflow: 'auto', 
                padding: '30px 40px', 
                marginBottom: 0,
                fontSize: 16,
                lineHeight: '1.7em',
                color: '#4a5568'
              }} dangerouslySetInnerHTML={{ __html: item.renderedContent }} />
              ) : (
                <div style={{ padding: '30px 40px' }}>
                  <h4 className={classes.descriptionText}><Entity entity={item.longDescription} /></h4>
                  <div style={{ marginTop: 30 }}>
                    {_.map(item.additionals, itemAdditional => (
                      <div className={classes.itemAdditionalContainer} key={itemAdditional.title}>
                        {itemAdditional.icon}
                        <Entity className={classes.itemAdditionalText} entity={itemAdditional.title} />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            {canEditSubscription ? (
              <div>
                {/* Pricing Section */}
                {!item.hidePrice && (
                  <>
                    <Divider style={{ margin: '20px 0' }} />
                    <div style={{ padding: '10px 30px' }}>
                      {this.renderPricingSection()}
                    </div>
                  </>
                )}
                {!item.isActive ? (
                  <div style={{ padding: '0 20px 20px 20px' }}>
                    <BaseStoreItemsActivationView
                      provisioningType={provisioningType}
                      requestToQuote={requestToQuote}
                      isCompatible={isCompatible}
                      isFreeItem={isFreeItem}
                      incompatibleAdditionalNotes={incompatibleAdditionalNotes}
                      onActivateSubscription={() => onActivateSubscription(selectedItem)}
                      onRequestActivation={() => onRequestActivation(selectedItem)}
                      onRequestQuotation={() => onRequestQuotation(selectedItem)}
                      onRequestSemiAutomaticActivation={() => onRequestSemiAutomaticActivation(selectedItem)}
                    />
                    <Divider style={{ margin: '20px 10px' }} />
                    <h4 className={classes.requestDemoText} style={{ padding: '0 10px' }}>
                      <Entity entity="requestADemoDescription" />
                    </h4>
                    <MDButton
                      containerStyle={{ marginTop: 15, padding: '0 10px' }}
                      title={<Entity entity="requestADemoTitle" />}
                      backgroundColor={BLUE}
                      titleStyle={{ fontWeight: 'bold', fontSize: 16 }}
                      style={{ marginTop: 0, height: 48 }}
                      onClick={() => onRequestDemo()}
                    />
                  </div>
                ) : (
                  <div style={{ height: 10 }} />
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(StoreItemDescriptionView);
